import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Grid, Button, IconButton } from '@mui/material';
import SoftButton from 'components/SoftButton';
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import { useUpdateAgencyConfig } from 'queries/configurator';
import { useAgencyInfo } from 'context/agency';

const Category = ({ categories, setCategories, handleSubmit, loading }) => {
    const [open, setOpen] = useState(false);
    const [categoryName, setCategoryName] = useState('');
    const [categoryColor, setCategoryColor] = useState('#3B82F6');
    const [agency, Update] = useAgencyInfo();

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const submitCategory = (e) => {
        const Categories = {
            id: window.crypto.randomUUID(),
            name: categoryName,
            color: categoryColor,
        };

        handleSubmit(e, Categories);
        handleClose();
        setCategoryName('');
        setCategoryColor('#3B82F6');
    };

    // "categories" is the resource name any other tab reading the agency's
    // category list would guess too, so cross-cluster invalidation lines up
    // even though it's currently only read off the agency doc directly.
    const updateCategoriesMutation = useUpdateAgencyConfig(true);

    const updateAgencyCategories = async (updatedCategories) => {
        const payload = {
            _id: agency._id,
            domainUpdate: false,
            domain: agency?.Customization?.domain,
            Customization: agency?.Customization,
            Categories: updatedCategories,
        };

        try {
            const { response } = await updateCategoriesMutation.mutateAsync(payload);
            if (response) {
                Update(response.data);
            }
        } catch (error) {
            console.log('An error occurred');
        }
    };

    const handleDelete = (id) => {
        const updatedCategories = categories.filter(cat => cat.id !== id);
        setCategories(updatedCategories);
        updateAgencyCategories(updatedCategories);
    };



    return (
        <div>
            <Grid item xs={12} className="px-2" display="flex" justifyContent={"flex-end"}>
                <SoftButton
                    className="bg-dark"
                    color="dark"
                    type="button"
                    onClick={handleOpen}
                    disabled={loading}
                    style={{
                        cursor: loading ? "not-allowed" : "pointer",
                    }}
                >
                    Create New Category
                </SoftButton>
            </Grid>

            <Grid item xs={12}>
                <h4>Categories:</h4>
                {categories.map(cat => (
                    <div key={cat.id} style={{ margin: '5px 0', display: 'flex', alignItems: 'center', border: '1px solid #E7E9EC', borderRadius: '5px', padding: '10px', justifyContent: 'space-between' }}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <div style={{ width: '15px', height: '15px', borderRadius: '20px', backgroundColor: cat.color, marginRight: '10px' }}></div>
                            <span>{cat.name}</span>
                        </div>
                        <IconButton size="small" color="error" onClick={() => handleDelete(cat.id)}>
                            <DeleteIcon fontSize="small" />
                        </IconButton>
                    </div>
                ))}
            </Grid>

            <Dialog open={open} onClose={handleClose} fullWidth maxWidth="xs">
                <DialogTitle>
                    Create New Category
                    <IconButton
                        aria-label="close"
                        onClick={handleClose}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers>
                    <TextField
                        autoFocus
                        margin="dense"
                        fullWidth
                        placeholder="e.g., Content Creation"
                        value={categoryName}
                        onChange={(e) => setCategoryName(e.target.value)}
                    />
                    <div style={{ position: "relative", display: 'flex', alignItems: 'center', marginTop: '20px' }}>
                        <div
                            style={{
                                width: '30px',
                                height: '30px',
                                backgroundColor: categoryColor,
                                border: '1px solid #ccc',
                                borderRadius: '4px',
                                cursor: 'pointer',
                                marginRight: '10px',
                                position: 'relative',
                            }}
                        >
                            <input
                                type="color"
                                id="color-picker"
                                style={{
                                    display: 'block',
                                    position: 'absolute',
                                    left: 0,
                                    top: 0,
                                    width: '30px',
                                    height: '30px',
                                    opacity: 0,
                                    cursor: 'pointer',
                                    zIndex: 2
                                }}
                                value={categoryColor}
                                onChange={(e) => setCategoryColor(e.target.value)}
                                tabIndex={-1}
                            />
                            <div
                                style={{
                                    position: 'absolute',
                                    left: 0,
                                    top: 0,
                                    width: '30px',
                                    height: '30px',
                                    zIndex: 1
                                }}
                                onClick={() => document.getElementById('color-picker').click()}
                            />
                        </div>
                        <TextField
                            value={categoryColor}
                            onChange={(e) => setCategoryColor(e.target.value)}
                            fullWidth
                        />
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="secondary">
                        Cancel
                    </Button>
                    <Button
                        onClick={submitCategory}
                        disabled={!categoryName || loading}
                        variant="contained"
                        color="primary"
                    >
                        Create Category
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default Category;
